module.exports = __webpack_public_path__ + "static/media/doxper-svg-logo.6173bfea.svg";